<template>
    <div>
        <div class="accordion-container">
            <Accordion
                title="2.1. Ausrichtung auswählen"
                info="Wähle zwischen Hochformat (Portrait) und Querformat (Landscape) aus."
                :open="this.openAccordion==1"
                :isDisabled="isDisabled(1)"
                :class="{'disabled': isDisabled(1)}"
                @click="toggleAccordion(1)">
                <div class="my-2 flex">
                    <div class="canvas-format format-landscape cursor-pointer"
                        @click="setOrientation('landscape')"
                        :class="{active: (stageConfiguration.orientation === 'landscape')}"
                    >
                        <div class="canvas-preview"></div>
                        <div class="label">Querformat</div>
                    </div>

                    <div class="canvas-format format-portrait cursor-pointer"
                        @click="setOrientation('portrait')"
                        :class="{active: (stageConfiguration.orientation === 'portrait')}"
                    >
                        <div class="canvas-preview"></div>
                        <div class="label">Hochformat</div>
                    </div>
                </div>
                <!--<div class="mt-5 flex">
                    <label class="whitespace-nowrap mr-5">
                        <Checkbox type="radio" name="format" checkValue="4-3" v-model="stageConfiguration.format">4:3</Checkbox>
                    </label>
                    <label class="whitespace-nowrap mr-5">
                        <Checkbox type="radio" name="format" checkValue="3-2" v-model="stageConfiguration.format">3:2</Checkbox>
                    </label>
                    <label class="whitespace-nowrap">
                        <Checkbox type="radio" name="format" checkValue="panorama" v-model="stageConfiguration.format">Panorama</Checkbox>
                    </label>
                </div>-->
            </Accordion>

            <Accordion
                title="2.2. Stil auswählen"
                info='Wähle einen der vier Stile für die Amplitude! Ebenso kannst du den Ausschlag der Amplitude vergrößern oder verkleinern.'
                :open="this.openAccordion==2"
                :isDisabled="isDisabled(2)"
                :class="{'disabled': isDisabled(2)}"
                @click="toggleAccordion(2)">
                <WaveStyle></WaveStyle>

                <!-- configure border -->
                <div class="peaks-border-container" :class="{'grid grid-cols-2': waveConfigurations.length == 1}">
                    <!-- Select amplitude -->
                    <div v-if="waveConfigurations.length > 1" class="tabs flex text-green">
                        <span class="tab flex py-2 px-3" v-for="(wave, idx) in waveConfigurations"
                            :class="{'active': activeAmplitude==idx}">
                            <a href="#"
                               class="text-green uppercase"
                               :class="{'font-semibold': activeAmplitude==idx}"
                               @click="activeAmplitude=idx"
                            ><span class="tab-icon"></span>{{ idx+1 }}</a>
                        </span>
                    </div>

                    <!-- Configure amplitude -->
                    <div v-for="(wave,idx) in waveConfigurations">
                        <div v-show="activeAmplitude==idx">
                            <AmplitudeStyle :wave="wave" :idx="idx" class="pt-3"></AmplitudeStyle>
                        </div>
                    </div>

                    <div class="mt-5"
                        :class="{'pt-4 pl-4': waveConfigurations.length == 1}">
                        <!--
                            <Checkbox type="checkbox"
                                name="border"
                                v-model="border"
                                checkValue="free"
                                uncheckValue="none"
                                connected="true"
                                @change="setBorder()"
                            >Freier Rand</Checkbox>
                        -->

                        <Checkbox type="checkbox"
                            name="border"
                            v-model="border"
                            v-show="backgroundType !== 'image'"
                            checkValue="border"
                            uncheckValue="free"
                            connected="true"
                            @change="setBorder()"
                        >Umrandung</Checkbox>
                    </div>
                </div>
            </Accordion>

            <Accordion
                title="2.3. Hintergrund & Farben"
                info="Lade dein persönliches Hintergrundbild hoch oder wähle alternativ aus unseren Vorlagen deine Wunschfarben für die Amplitude und den Hintergrund aus."
                :open="this.openAccordion==3"
                :isDisabled="isDisabled(3)"
                :class="{'disabled': isDisabled(3)}"
                @click="toggleAccordion(3)">
                <BackgroundColors></BackgroundColors>
            </Accordion>

            <!-- <Accordion
                title="2.4. Amplitude anpassen"
                info="Passe den Ausschlag und die Transparenz deiner Amplitude an, indem du den jeweiligen Regler nach links und rechts schiebst oder auf + und – klickst."
                :open="this.openAccordion==4"
                @click="toggleAccordion(4)">
                <div v-if="waveConfigurations.length > 1" class="tabs flex text-green">
                    <span class="tab flex py-2 px-3" v-for="(wave, idx) in waveConfigurations"
                        :class="{'active': activeAmplitude==idx}">
                        <a href="#"
                           class="text-green uppercase"
                           :class="{'font-semibold': activeAmplitude==idx}"
                           @click="activeAmplitude=idx"
                        ><span class="tab-icon"></span>{{ idx+1 }}</a>
                    </span>
                </div>

                <div v-for="(wave,idx) in waveConfigurations">
                    <div v-show="activeAmplitude==idx">
                        <AmplitudeStyle :wave="wave" :idx="idx" class="pt-3"></AmplitudeStyle>
                    </div>
                </div>
            </Accordion> -->

            <!-- <Accordion
                title="2.4. Amplitude zuschneiden"
                info="Für eine bessere Optik kannst du die Amplitude zuschneiden. Dazu schiebst du einfach die Regler links und rechts von deiner Stimmamplitude auf die gewünschte Position und klickst dann auf „ZUSCHNITT SPEICHERN“. Dabei wird nur die Amplitude optisch zugeschnitten, die anfangs aufgenommene Stimme bleibt weiterhin vollständig abspielbar. Wenn du deine Amplitude nicht zuschneiden möchtest, kannst du einfach auf „WEITER“ klicken."
                :open="this.openAccordion==4"
                @click="toggleAccordion(4)">
                <CropAmplitude :open="this.openAccordion==4" class="pt-3"></CropAmplitude>
            </Accordion> -->

        </div>
    </div>
</template>

<script type="text/javascript">
import WaveStyle from "./WaveStyle.vue";
import { mapFields } from 'vuex-map-fields';
import AmplitudeStyle from "./AmplitudeStyle.vue";
import CropAmplitude from "./CropAmplitude.vue";
import BackgroundColors from "./BackgroundColors.vue";
import Pipeline from "~/scripts/Pipeline/Pipeline.js";
import Checkbox from '~/scripts/Components/Checkbox.vue';
import Accordion from "~/scripts/Components/Accordion.vue";

export default {
    components: {
    Checkbox,
    Accordion,
    WaveStyle,
    CropAmplitude,
    AmplitudeStyle,
    BackgroundColors,
    BackgroundColors
},
    data() {
        return {
            border: 0,
            activeAmplitude: 0,
            activeAmplitudeColors: 0
        };
    },
    mounted() {
        this.border = this.$store.state.stageConfiguration.border;
    },
    computed: {
        ...mapFields({
            step: 'step',
            openAccordion: 'substep',
            substepsDisabled: 'substepsDisabled',
            availableSubsteps: 'availableSubsteps',
            stageConfiguration: 'stageConfiguration',
            waveConfigurations: 'waveConfigurations',
            backgroundType: 'stageConfiguration.background.type'
        })
    },
    methods: {
        /**
         * Change orientation of canvas
         */
        setOrientation(orientation) {
            this.stageConfiguration.orientation = orientation;

            this.$store.commit('updateField', {
                path: 'selectedFrameSize',
                value: null
            });
        },

        toggleAccordion(number) {
            if (!this.isDisabled(number)) {
                this.openAccordion = number != this.openAccordion ? number : 1;
            }
        },

        isDisabled(number) {
            return this.substepsDisabled[2].indexOf(number) !== -1;
        },

        /**
         * Change border
         */
        setBorder() {
            this.$store.commit('updateField', {
                path: `stageConfiguration.border`,
                value: this.border
            });

            setTimeout(() => {
                Pipeline.updateStageBorder();
                Pipeline.soundFilesToWaveForm();
            }, 100);
        }
    }
}
</script>
